module.exports = __webpack_public_path__ + "img/MOMO1.dc9cb9cf.svg";